import { FirebaseRemoteConfig } from "./plugins";
import { throwErrorWithStack } from "./crashlytics";
import store from "./store";
import { getLogger } from "./logging";

const log = getLogger("🔀 Remote config");

// const activate = async () => {
//   try {
//     await FirebaseRemoteConfig.activate();
//   } catch (error) {
//     throwErrorWithStack(error);
//   }
// };

const fetchConfig = async () => {
  try {
    await FirebaseRemoteConfig.fetchConfig({
      minimumFetchIntervalInSeconds: __DEV__ ? 1 : 43200,
    });
  } catch (error) {
    throwErrorWithStack(error);
  }
};

const fetchAndActivate = async () => {
  try {
    await FirebaseRemoteConfig.fetchAndActivate();
  } catch (error) {
    throwErrorWithStack(error);
  }
};

const getNumber = async (key) => {
  const { value } = await FirebaseRemoteConfig.getNumber({
    key,
  });
  return value;
};

async function setup() {
  await fetchConfig();
  await fetchAndActivate();
}

async function getValues() {
  try {
    const ret = await Promise.all([
      getNumber("landscape_interstitial_ads_interval"),
      getNumber("animation_speed"),
    ]);

    ret[0] && store.set("interstitialAdsInterval", ret[0]);
    ret[1] && store.set("animationSpeed", ret[1]);
    log.info(`<interstitialAdsInterval=${ret[0]}, animationSpeed=${ret[1]}>`);
  } catch (error) {
    throwErrorWithStack(error);
  }
}

async function main() {
  await setup();
  await getValues();
}

main();
